import commonEnHK from './common_en-HK'

const stocktakeEnHK = {
  stocktake: {
    ...commonEnHK,
  }
}

export default stocktakeEnHK